<template>
  <div>
    <el-row type="flex" justify="center" class="register">
      <el-col :span="24" class="member_out">
        <p class="title">注册为“江苏省音乐家协会”的用户</p>
        <el-form :model="registerForm" :rules="rules2" ref="formData" class="ruleForm">
          <div>
            <div class="formCon">
              <el-form-item prop="account" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconuser"></i>
                </div>
                <el-input v-model="registerForm.account" class="inpStyle" placeholder="填写您的登陆账号"></el-input>
              </el-form-item>
              <el-form-item prop="password" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconpass"></i>
                </div>
                <el-input
                  type="password"
                  v-model="registerForm.password"
                  class="inpStyle"
                  placeholder="填写您的登录密码"
                ></el-input>
              </el-form-item>
              <el-form-item prop="checkPassword" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconpass"></i>
                </div>
                <el-input
                  type="password"
                  v-model="registerForm.checkPassword"
                  class="inpStyle"
                  placeholder="确认密码"
                ></el-input>
              </el-form-item>
              <el-form-item prop="name" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconnickname"></i>
                </div>
                <el-input v-model="registerForm.name" class="inpStyle" placeholder="昵称"></el-input>
              </el-form-item>
             
              <el-form-item prop="identity" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconidenti"></i>
                </div>
                <el-input v-model="registerForm.identity" class="inpStyle" placeholder="身份证号"></el-input>
              </el-form-item>
               <el-form-item >
                      <div>
                       <p>（*无居民身份证的可输入护照号）</p>
                      </div>
              </el-form-item>
              <el-form-item prop="email" class="form_cc">
                <div class="form_icon">
                  <i class="icon iconemail"></i>
                </div>
                <el-input v-model="registerForm.email" class="inpStyle" placeholder="Email"></el-input>
              </el-form-item>
              <el-form-item prop="code" class="form_dd">
                <div style="display:flex;">
                  <div class="form_icon">
                    <i class="icon iconverifi"></i>
                  </div>
                  <!-- <div > -->
                  <el-input
                    style="text-align:left;"
                    v-model="registerForm.code"
                    class="inpStyle inputCode"
                    placeholder="验证码"
                  ></el-input>
                  <!-- <el-button class="code" @click="createCode" v-model="checkCode"></el-button> -->
                  <div>
                    <input type="button" @click="createCode" v-model="checkCode" class="code_check">
                  </div>
                  <!-- </div> -->
                </div>
              </el-form-item>
              <!-- <el-form-item prop="account">
                      <i class="icon iconuser"></i>
                      <input type="text" v-model='registerForm.account' class="inpStyle" placeholder="填写您的登陆账号">
              </el-form-item>-->
              <!-- <el-form-item prop="password">
                      <i class="icon iconpass"></i>
                      <input type="password" v-model='registerForm.password' class="inpStyle" placeholder="填写您的登陆密码">
              </el-form-item>-->
              <!-- <el-form-item prop="checkPassword">
                      <i class="icon iconpass"></i>
                      <input type="password" v-model='registerForm.checkPassword' class="inpStyle" placeholder="确认密码">
              </el-form-item>-->
              <!-- <el-form-item prop="name">
                      <i class="icon iconnickname"></i>
                      <input type="text" v-model='registerForm.name' class="inpStyle" placeholder="昵称">
              </el-form-item>-->
              <!-- <el-form-item prop="identity">
                      <i class="icon iconidenti"></i>
                      <input type="text" v-model='registerForm.identity' class="inpStyle" placeholder="身份证号">
                    </el-form-item>
                    <el-form-item prop="email">
                      <i class="icon iconemail"></i>
                      <input type="text" v-model='registerForm.email' class="inpStyle" placeholder="Email">
              </el-form-item>-->
              <!-- <el-form-item prop="code">
                      <i class="icon iconverifi"></i>
                      <input type="text" v-model='registerForm.code' class="inpStyle inputCode" placeholder="验证码">
                      <input type="button" @click="createCode" v-model="checkCode" class="code">
              </el-form-item>-->
            </div>
            <div>
              <el-form-item>
                <button class="loginBtn" @click.prevent="register2Form('formData')">注册</button>
              </el-form-item>
            </div>
            <div class="loginDea">
              <!-- <a class="cor" @click="()=>{this.$router.push({name:'ForgetPassword'})}" >忘记密码了?</a> -->
              <a
                class="cor"
                @click="()=>{this.$router.push({name:'message'})}"
                style="vertical-align:middle;"
              >
                已有账号，立即登录&nbsp;
                <i class="icon iconarrow"></i>
              </a>
            </div>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <!-- </el-col>
    </el-row>-->
    <!-- <p class="box_footer">省音协考级报名咨询电话 025-83572077</p> -->
  </div>
  <!-- </div> -->
</template>
<script>
export default {
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // var validateEmail = (rule, value, callback) =>{
    //       if (value === '') {
    //       callback(new Error('请正确填写邮箱'));
    //   } else {
    //     if (value !== '') {
    //       var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //       if(!reg.test(value)){
    //         callback(new Error('请输入有效的邮箱'));
    //       }
    //     }
    //     callback();
    //   }
    // };
    return {
      registerForm: {
        account: "",
        password: "",
        checkPassword: "",
        name: "",
        identity: "",
        email: "",
        code: ""
      },
      rules2: {
        account: [{ required: true, message: "账户不能为空", trigger: "blur" }],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        name: [{ required: true, message: "昵称不能为空", trigger: "blur" }],
        identity: [
          { required: true, message: "证件号不能为空", trigger: "blur" }
        ],
        // email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        // code: [{ required: true, message: "验证码错误", trigger: "blur" }],
        checkPassword: [{ validator: validatePass1, trigger: "blur" }]
      },
      checkCode: ""
    };
  },
  created() {
    this.createCode();
    console.log(localStorage.getItem("token"));
  },
  methods: {
    register2Form(formData) {
      let self = this;
      let flag = true;
      if(this.registerForm.code.toLocaleUpperCase()==this.checkCode.toLocaleUpperCase()){
        flag = true;
      }else{
        flag =false
        this.$message.error("验证码错误");
      }
      // localStorage.removeItem('token')
      this.$refs[formData].validate(valid => {
        if (valid) {
          let dataList = {
            account: this.registerForm.account,
            password: this.registerForm.password,
            idNumber: this.registerForm.identity,
            name: this.registerForm.name,
            email: this.registerForm.email
          };
          console.log(1234567890876543456)
          if(flag){
            window.Global.post("/user/register", dataList, rs => {
            if (rs.status == 200) { 
              console.log(rs.status);
              self.$message.success("注册成功");
              self.$router.push({ name: "message" });
              } else {
                self.$message.error(rs.data.message);
              }
            });
          }
        } else {
          self.$message.error('请完善信息');
        }
      });
    },
    createCode() {
      //先清空验证码的输入
      this.code = "";
      this.checkCode = "";
      this.picLyanzhengma = "";
      //验证码的长度
      var codeLength = 4;
      //随机数
      var random = new Array(
        0,1,2,3,4,5,6,7,8,9,"A","B","C","D","E","F","G","H","I","J","K","L","M","N","O",
        "P","Q","R","S","T","U","V","W","X","Y","Z","a","b","c","d","e","f","g","h","i","j",
        "k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"
      );
      for (var i = 0; i < codeLength; i++) {
        //取得随机数的索引（0~35）
        var index = Math.floor(Math.random() * 62);
        //根据索引取得随机数加到code上
        this.code += random[index];
      }
      //把code值赋给验证码
      this.checkCode = this.code;
    },
    // submitForm(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       alert("submit!");
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // }
  },
  watch: {
    checkCode: {
      handler() {

        console.log(this.checkCode);
      }
    }
  }
};
</script>
<style lang="less">
@import "../../static/less/register.less";
</style>


// WEBPACK FOOTER //
// src/components/Register.vue